import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import divideArrow from "../../../assets/svg/divideArrow.svg";
import { logoutFunction } from "../../custom/commonFunction";
import axios from "axios";
import { GET_DOCUMENT_BY_ID } from "../../../helpers/endpointService";

function Breadcrumbs({ location }) {
  const pathSegments = location.pathname.split("/").filter((x) => x);
  const navigate = useNavigate();
  const dataFetchedRef = useRef(false);
  const categoryList = useSelector(
    (state) => state.documentReducer.allCategory
  );
  const [documentDetails, setDocumentDetails] = useState({ documentNo: "" });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    const fetchDocumentDetails = async () => {
      setIsLoading(true);
      const documentId = parseInt(pathSegments[3]);
      let propApiUrl = `${GET_DOCUMENT_BY_ID}?docId=${documentId}`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            setDocumentDetails(response.data);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          logoutFunction(err?.response?.status);
        });
      /*  try {
        const documentId = parseInt(pathSegments[3]); // Assuming the document ID is at index 3
        const propApiUrl = `${GET_DOCUMENT_BY_ID}?docId=${documentId}`;
        setIsLoading(true);
        const response = await axios.get(propApiUrl);
        setDocumentDetails(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      } */
    };

    if (pathSegments?.length >= 4 && documentDetails?.documentNo === "") {
      //
      fetchDocumentDetails();
    }
  }, [pathSegments]);

  function getCategoryNameById(categories, categoryId, categoryLevel) {
    if (categories && categoryId) {
      if (categoryLevel === 1) {
        for (const category1 of categories) {
          if (category1.category1Id === categoryId) {
            return category1.category1Name;
          }
        }
      } else if (categoryLevel === 2) {
        for (const category1 of categories) {
          for (const category2 of category1.category2) {
            if (category2.category2Id === categoryId) {
              return category2.category2Name;
            }
          }
        }
      } else if (categoryLevel === 3) {
        if (documentDetails?.documentNo && !isLoading) {
          return documentDetails?.documentNo?.split("Ver")[0];
        }
      }
    }
    return null;
  }

  if (!categoryList) {
    return null;
  }

  const breadcrumbs = pathSegments?.map((segment, index) => {
    const path = `/${pathSegments?.slice(0, index + 1).join("/")}`;
    const categoryId = parseInt(segment);
    let categoryLevel;

    if (index === 0) {
      categoryLevel = 1; // Document level
    } else if (index === 1) {
      categoryLevel = 1; // Category 1 level
    } else if (index === 2) {
      categoryLevel = 2; // Category 2 level
    } else if (index === 3) {
      categoryLevel = 3; // Document details level
    }

    const category = getCategoryNameById(
      categoryList,
      categoryId,
      categoryLevel
    );
    const label = category ? category : segment;
    return { label, path };
  });

  return (
    <div
      className={
        window.innerWidth < 850
          ? "category categoryShiftof d-flex flex-wrap"
          : "category categoryShifton"
      }
    >
      {breadcrumbs && breadcrumbs?.length > 0 ? (
        breadcrumbs?.map(({ label, path }, index) => (
          <React.Fragment key={path}>
            <span
              style={{ cursor: "pointer"}}
              className={
  
                index === breadcrumbs?.length - 1 ? "catActive" : index===0 ? "Doc" : "cat" 
              }
              onClick={() => navigate(path)}
            >
              {index === 0 ? "Documents" : label}
            </span>
            {index < breadcrumbs?.length - 1 && (
              <span className="catDivide">
                <img src={divideArrow} alt="divider arrow"/>
              </span>
            )}
          </React.Fragment>
        ))
      ) : (
        <span>Documents</span>
      )}
    </div>
  );
}

export default Breadcrumbs;
